import React from 'react';
import {style, classes} from './doppe-viewer-text-box.st.css';
import {TextBox, reactCreateMemo} from '@wix/devzai-utils-react';

export const DoppeViewerTextBox = reactCreateMemo(React.forwardRef(function DoppeViewerTextBox(
    props: DoppeViewerTextBox.Props,
    ref: React.Ref<TextBox>
) {
    const {
        hasError,
        className,
        ...htmlAttributes
    } = props;

    return (
        <TextBox
            {...htmlAttributes}
            className={style(classes.root, {hasError: hasError}, className)}
            ref={ref}
        />
    );
}));

export namespace DoppeViewerTextBox {

    export interface Props extends TextBox.Props {
        hasError?: boolean;
    }
}
